module.exports = __webpack_public_path__ + "protichinta-icon-4e9bfabeeeb95dbb4508.png";